import React from 'react'
import {
    bottompanelify, Wrapper,
    BottomPanel, BottomContainer
} from 'utilities/panel'

const GenericBottomPanel = ({ children, className, salt, ...props }) => {
    const {
        show = false,
        dismiss,
        ...sidePanel
    } = props

    const animate = show ? 'in' : 'out'

    return bottompanelify(
        <Wrapper>
            {!!show && (
                <BottomPanel
                    {...sidePanel}
                    dismiss={dismiss}
                    key={`side-panel:generic:${salt}`}>
                    <BottomContainer
                        {...(className ? { className } : null)}
                        animate={animate}
                        {...(!show ? { inert: 'true' } : null)}>
                        {children}
                    </BottomContainer>
                </BottomPanel>
            )}
        </Wrapper>
    )
}

export default GenericBottomPanel